export default "__VITE_ASSET__DC4BiIBG__"